import { Navigate, Route, Routes } from 'react-router-dom';

import { ErrorPage } from '~/components/ErrorPage';
import { useUser } from '~/modules/auth/hooks/useUser';
import { useFeatureFlags } from '~/modules/experiments/hooks/useFeatureFlags';

import { FEATURE_FLAGS } from '../experiments/features';
import { TabsPagesLayout } from './components';
import { LabelRouter } from './modules/label/router';
import { LabelGroupRouter } from './modules/label-group/router';
import { SublabelRequestRouter } from './modules/sublabel-request/router';
import { UserRouter } from './modules/user/router';

/**
 * Top-level router combining module-level routers
 */
function Router() {
  const { hasPermission } = useUser();

  const canViewLabelGroups = hasPermission('LABEL_GROUP.VIEW');

  const [labelGroupsEnabled] = useFeatureFlags([
    FEATURE_FLAGS.ContainerSettingsLabelGroups,
  ]);

  return (
    <Routes>
      <Route element={<TabsPagesLayout />}>
        <Route index element={<Navigate replace to="users" />} />
      </Route>

      <Route path="users/*" element={<UserRouter />} />
      <Route path="labels/*" element={<LabelRouter />} />
      <Route path="sublabel-requests/*" element={<SublabelRequestRouter />} />

      {canViewLabelGroups && labelGroupsEnabled ? (
        <Route path="label-groups/*" element={<LabelGroupRouter />} />
      ) : null}

      <Route path="*" element={<ErrorPage type="notFoundPage" />} />
    </Routes>
  );
}

Router.displayName = 'SettingsRouter';

export { Router };
